<app-template-popup-visitor [width]="600" [size]="dataReceived.size" [Document_Logo_URL]="dataReceived.data.Document_Logo_URL">
    <ng-container titre-popup>
        {{ dataReceived.title }}
    </ng-container>

    <ng-container corps>
        <div class="d-flex flex-column justify-content-center align-items-around mb-2">
            <span>Votre compte à l'application My Factory n'est pas activé.</span>
    
            <span>Vous pouvez contacter la société {{ dataReceived.data.Nom_Commercial }}.</span>
    
            <span>Coordonnées : {{ dataReceived.data.Siege_Email }} / {{dataReceived.data.Siege_Telephone }}.</span>
        </div>
    </ng-container>

    <ng-container actions>
        <button class="BTN_GENERAL COLOR_Action_Default" mat-button mat-dialog-close (click)="onClosePopup()" >FERMER</button>
    </ng-container>

</app-template-popup-visitor>